<div class="buttons-container">
  <ul class="buttons-container__list">
    <li class="buttons-container__item">
      <button type="button" class="buttons-container__button" (click)="exportToExcel()" [disabled]="!isGridLoaded">
        <mat-icon>insert_drive_file</mat-icon>
        Export to Excel
      </button>
    </li>
    <li class="buttons-container__item">
      <button type="button" class="buttons-container__button short-button" (click)="showEmailModal()"
        [disabled]="disableOtherButtons">
        <mat-icon>email</mat-icon>
        Email
      </button>
    </li>
    <li class="buttons-container__item">
      <button type="button" class="buttons-container__button short-button" (click)="copyLink()"
        [disabled]="disableOtherButtons">
        <mat-icon>link</mat-icon>
        Link
      </button>
    </li>
    <li class="buttons-container__item">
      <button type="button" class="buttons-container__button" (click)="showLineItemsGLEntry()"
        [disabled]="disableOtherButtons">
        <mat-icon>description</mat-icon>
        View Line Item / GL Entry
      </button>
    </li>
    <li class="buttons-container__item">
      <button type="button" class="buttons-container__button" (click)="showViewHistory()"
        [disabled]="disableOtherButtons">
        <mat-icon>history</mat-icon>
        View Workflow History
      </button>
    </li>
    <li class="buttons-container__item">
      <button type="button" class="buttons-container__button" (click)="showDocumentHistory()"
        [disabled]="disableOtherButtons">
        <mat-icon>history</mat-icon>
        View Document History
      </button>
    </li>
    <li class="buttons-container__item">
      <button type="button" class="buttons-container__button" (click)="showDocumentNotesAdmin()"
        [disabled]="disableOtherButtons">
        <mat-icon>description</mat-icon>
        View / Add Document Notes
      </button>
    </li>
    <li class="buttons-container__item">
      <button type="button" class="buttons-container__button" (click)="showViewNotes()"
        [disabled]="disableOtherButtons">
        <mat-icon>group_work</mat-icon>
        View Workflow Notes
      </button>
    </li>
    <li class="buttons-container__item">
      <button type="button" class="buttons-container__button" (click)="showMultiDocumentNotesAdmin()"
        [disabled]="!enableViewSelectedButton">
        <mat-icon>insert_drive_file</mat-icon>
        View Selected Documents
      </button>
    </li>
    <li class="buttons-container__item" *ngIf="hideDelete">
      <button type="button" class="buttons-container__button" (click)="deleteDocument()"
        [disabled]="disableDeleteButtons">
        <mat-icon>delete</mat-icon>
        Delete Selected Documents
      </button>
    </li>
  </ul>
</div>
<div style="padding: 10px 15px 10px 15px;">
  <p class="ng-binding search-instruction"> Select a business area to load the search fields.
    Enter the values in any of the search fields and click the Search button to display the results in a grid.</p>
  <mat-accordion>
    <mat-expansion-panel style="background-color: #f2f2f2 !important;">
      <mat-expansion-panel-header style="height: 32px;">
        <mat-panel-title>
          <h2 mat-dialog-title class="dialog-header">
            <div class="header-left" style="font-size: 13px !important;">
              <mat-icon class="header-icon">zoom_in</mat-icon>
               SEARCH CRITERIA
            </div>
          </h2>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="row" style="display: inline-block;">
        <div class="col-sm-6">
          <div class="form-field-container">
            <label style="font-weight: 500; margin-bottom: 10px; font-size: 14px;">Business Area</label>
            <mat-form-field class="business-area-select" appearance="fill">
              <mat-select [(value)]="selectedBusinessArea"
                name="businessArea" placeholder="Select Business Area"
                (selectionChange)="getDocumentTypesBasedOnBusinessArea($event)">
                <ng-container *ngIf="!isBusinessAreaLoading; else loadingTemplate">
                  <mat-option [value]="null">Select Business Area</mat-option>
                  <mat-option *ngFor="let area of businessAreaList" [value]="area.id">{{ area.name }}</mat-option>
                </ng-container>
                <ng-template #loadingTemplate>
                  <mat-option disabled>
                    <mat-spinner diameter="20"></mat-spinner>
                  </mat-option>
                </ng-template>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="form-container">
        <div *ngIf="!isSearchFieldsLoading" class="custom-line"></div>
        <form [formGroup]="searchForm" (ngSubmit)="onSubmit(0)">
          <mat-spinner *ngIf="isSearchFieldsLoading" style="margin: auto; display: block;"></mat-spinner>
          <div formArrayName="searchFields" class="custom col-sm-12" *ngIf="!isSearchFieldsLoading">
            <ng-container *ngFor="let fieldControl of searchFieldsArray?.controls; let i = index">
            <div class="custom1 col-sm-6" *ngIf="searchFields[i]?.controlType !== 1" [formGroupName]="i" >
              <div class="custom2">
                <div class="custom3" [ngSwitch]="searchFields[i]!.controlName">
                  <div *ngSwitchCase="'TEXT_BOX'" class="custom4">
                    <mat-label class="custom5 labels col-sm-4">{{ searchFields[i]!.displayName }}</mat-label>
                    <mat-select style="width: 17%;" class="custom5 filter-selector col-sm-3" formControlName="filter">
                      <mat-option *ngFor="let option of searchFields[i]?.searchOperatorOptions | keyvalue"
                        [value]="option.key">
                        {{ option.value }}
                      </mat-option>
                    </mat-select>
                    <input matInput class="custom5 col-sm-4" formControlName="value"
                      placeholder="Enter {{ searchFields[i]!.displayName }}" />
                  </div>
                  <div *ngSwitchCase="'number'" class="custom4">
                    <mat-label class="custom5 labels col-sm-4">{{ searchFields[i]!.displayName }}</mat-label>
                    <mat-select style="width: 17%;" class="custom5 filter-selector col-sm-3" formControlName="filter">
                      <mat-option *ngFor="let option of searchFields[i]?.searchOperatorOptions | keyvalue"
                        [value]="option.key">
                        {{ option.value }}
                      </mat-option>
                    </mat-select>
                    <input matInput class="custom5 col-sm-4" formControlName="value"
                      placeholder="Enter {{ searchFields[i]!.displayName }}" />
                  </div>
                  <div *ngSwitchCase="'COMBO_BOX'" class="custom4"> 
                    <label class="custom5 labels col-sm-4">{{ searchFields[i]!.displayName }}</label>
                    <mat-select style="width: 17%;" class="custom5 filter-selector col-sm-3" formControlName="filter">
                      <mat-option *ngFor="let option of searchFields[i]?.searchOperatorOptions | keyvalue"
                      [value]="option.key">
                      {{ option.value }}
                      </mat-option>
                    </mat-select>
                    <mat-form-field class="" appearance="fill">
                      <mat-select class="custom5  col-sm-3" formControlName="value" placeholder="Select a value" [multiple]="searchFields[i]!.isComboMultiSelect">
                        <mat-option [value]=""  [disabled]="searchFields[i]!.isComboMultiSelect">Select a value</mat-option>
                        <mat-option *ngFor="let option of searchFields[i]?.comboValues" [value]="option.comboValue">
                        {{ option.comboValue }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                  <div *ngSwitchCase="'CHECK_BOX'" class="custom4">
                    <label class="custom5 labels col-sm-4">
                      {{ searchFields[i]!.displayName }}
                    </label>

                    <div class="custom5 col-sm-4 checkbox-container">
                      <mat-checkbox formControlName="yes" (change)="onCheckboxChange(i, 'yes')">Yes</mat-checkbox>
                      <mat-checkbox formControlName="no" (change)="onCheckboxChange(i, 'no')">No</mat-checkbox>
                    </div>
                  </div>
                  <div *ngSwitchCase="'DATE'" class="custom4">
                    <mat-label class="custom5 labels col-sm-4">
                      {{ searchFields[i]!.displayName }}
                    </mat-label>
                    <div class="custom5 col-sm-6">
                      <mat-date-range-input [rangePicker]="picker">
                        <input style="width: 100%;" matStartDate [placeholder]="getDatePlaceholder(i, 'start')"
                          (focus)="onRangePickerOpened(i)" (dateChange)="onRangeDateChange($event, i, 'start')"
                          [formControlName]="'startDate' + searchFields[i]!.columnName" />

                        <input style="width: 100%;" matEndDate [placeholder]="getDatePlaceholder(i, 'end')"
                          (focus)="onRangePickerOpened(i)" (dateChange)="onRangeDateChange($event, i, 'end')"
                          [formControlName]="'endDate' + searchFields[i]!.columnName" />
                      </mat-date-range-input>
                      <mat-datepicker-toggle style="padding-left: 35px;" matIconSuffix
                        [for]="picker"></mat-datepicker-toggle>
                      <mat-date-range-picker #picker></mat-date-range-picker>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </ng-container>
          </div>
          <div class=" display-buttons col-sm-12" *ngIf="searchFieldsArray?.length && searchFieldsArray.length > 0">
            <div class="d-flex justify-content-end align-items-center">
              <button mat-raised-button class="col-sm-3 submit" type="submit">Search</button>
              <button mat-raised-button type="button" class="col-sm-3 reset" (click)="resetForm()">Reset</button>
            </div>
          </div>
        </form>
      </div>
    </mat-expansion-panel>
    
    <mat-expansion-panel #searchResultsPanel>
      <mat-expansion-panel-header style="height: 32px;">
        <mat-panel-title>
          <h2 mat-dialog-title class="dialog-header">
            <div class="header-left" style="font-size: 13px !important;">
              <mat-icon class="header-icon">search</mat-icon>
               SEARCH RESULTS
            </div>
          </h2>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="row" *ngIf="hasSearched && !isDataAvailable">
        <div class="data-not-found">
          No results matching the search criteria was found. Please change the search criteria and re-try.
        </div>
      </div>
      <div *ngIf="isDataAvailable">
        <p-table 
        [columns]="columns" 
        [value]="workItems"  
        [rows]="rows" 
        [totalRecords]="totalRecords"
        [paginator]="true" 
        [first]="pageNo"
        [(selection)]="selectedWorkItems"
        [sortField]="sortField" 
        [sortOrder]="sortOrder"
        (onColReorder)="onColumnReordered($event)"
        [reorderableColumns]="true"  
        sortMode="multiple"
        (onPage)="onPageChange($event)" 
        [loading]="isTableLoading" 
        [loadingIcon]="''" 
        [resizableColumns]="true"
        columnResizeMode="expand">
          <ng-template pTemplate="paginatorright">
            <div class="p-text-right">
              <label for="perPage" class="p-mr-2">Rows per page:</label>
              <select id="perPage" class="p-inputtext" (change)="onRowsChange($event )">
                <option *ngFor="let option of rowsOptions" [value]="option.value">
                  {{ option.label }}
                </option>
              </select>
            </div>
          </ng-template>
          <ng-template pTemplate="header" let-columns>
            <tr>
              <th *ngFor="let col of columns" pReorderableColumn pResizableColumn scope="col">
                <div class="top-div">
                  <div class="text-section"><span [pSortableColumn]="col.field">{{ col.title }}</span></div>
                  <div class="spacer"><p-sortIcon [field]="col.field" /></div>
                  <div>
                    <p-columnFilter class="icon-section" [ngClass]="{'active': col.advancefilter.isAdvanceFilterUsed}" #filterRef [type]="col.type" 
                      [field]="col.field" display="menu" [showMatchModes]="false" [showOperator]="false" [filterModel]="col.advancefilter"> 
                      <ng-template pTemplate="filter" let-values let-filter="filterCallback" let-index="index">
                        <div class="rules-holder" *ngFor="let constraint of col.advancefilter!.constraints; let i = index">
                          <p *ngIf="i === 0">Show items with value that:</p>
                          <p-dropdown class="p-dropdown"
                            [options]="col.advancefilter!.matchModeOptions" [(ngModel)]="constraint.matchMode" optionLabel="label"
                            optionValue="value" (change)="onMatchModeChange($event, col.field, i)"/> 
                    
                          <input *ngIf="col.type == 'string' || col.type == 'number'"
                            type="text" pInputText class="p-inputtext"
                            [value]="constraint.value" (input)="onRuleChange($event, col.field, i)"/> 
                            
                          <p-calendar class="p-calendar" *ngIf="col.type == 'date'" [(ngModel)]="constraint.value"
                            [showTime]="true" [hourFormat]="'12'" [showIcon]="true"
                            [placeholder]="'Select date and time'" (onSelect)="onDateRuleChange($event, col.field, i)"></p-calendar>
                            
                          <div class="operator" *ngIf="i === 0" > 
                            <p-dropdown [options]="[
                                { label: 'And', value: 'and' },
                                { label: 'Or', value: 'or' }
                              ]"
                              [(ngModel)]="col.advancefilter.operator"
                              (onChange)="onOperatorChange($event, col.field)" class="p-dropdown" >
                            </p-dropdown>
                          </div>
                        </div>
                        <div class="p-d-flex p-jc-end p-ai-center p-gap-2">
                          <button pButton type="button" label="Apply" class="p-button-primary p-button-sm"
                            (click)="applyCall(col, filter, filterRef)">
                          </button>
                          <button pButton type="button" label="Clear" class="p-button-secondary p-button-sm"
                            (click)="clearCall(col, filter, filterRef)">
                          </button>
                        </div>
                      </ng-template> 
                    </p-columnFilter>
                  </div>
                </div>
                <div class="bottom-div">
                  <p-columnFilter [field]="col.field" matchMode="in" [showMenu]="false" (onClear)="customClear(col)">
                    <ng-template pTemplate="filter"> 
                      <p-multiSelect [options]="col.filterOptions" placeholder="Select"
                        [optionLabel]="'label'" [(ngModel)]="filters[col.field]"
                        appendTo="body" (onChange)="customFilter(col.type)"
                        [panelStyle]="{ 'z-index': '1000', 'max-height': '200px', 'overflow-y': 'auto' }"> 
                        <ng-template let-option pTemplate="item">
                          <div class="inline-block vertical-align-middle">
                            <span class="ml-1 mt-1">{{ option.label }}</span>
                          </div>
                        </ng-template>
                      </p-multiSelect>
                    </ng-template>
                  </p-columnFilter>
                    <button class="clear-button" mat-icon-button
                      *ngIf="filters[col.field]?.length || col.advancefilter.isAdvanceFilterUsed" (click)="customClear(col)">
                      <mat-icon class="clear-button-icon" >close</mat-icon>
                    </button> 
                </div>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-columns="columns" let-selected="selected" let-index="rowIndex">
            <tr [pSelectableRow]="rowData" [class.selected-row]="selected"
            [ngClass]="{ 'p-highlight': isSelected(index) }" 
            (click)="onRowClick($event,index)" (mousedown)="onMouseDown($event,index)"
            (mouseover)="onMouseOver($event,index)" (mouseup)="onMouseUp()" (keydown)="onRowKeydown($event, index)" (focus)="onRowFocus($event, index)">
              <td *ngFor="let col of columns" (dblclick)="copyToClipboard(rowData[col.field])">
                <ng-container *ngIf="col.field == 'View_Document'; else textContent">
                  <a (click)="openDocument(rowData[col.field], $event)" (contextmenu)="handleRightClick($event)">{{ col.title }}</a>
                </ng-container>
                <ng-template #textContent>
                  {{ rowData[col.field] }}
                </ng-template>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="paginatorleft" let-state>
            <div class="custom-paginator-text">
              {{ state.first + 1 }} - {{ min(state.first + state.rows, state.totalRecords) }} of {{ state.totalRecords }} items
            </div>
          </ng-template>
        </p-table>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>